<template>
<div>edit group</div>
</template>

<script>
export default {
  name: 'EditReservationGroup',
}
</script>

<style scoped>

</style>
